import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import ShowMore from '../show-more';
import * as S from './styles';

type OwnProps = {
  className?: string;
  countryCode: string;
  countryName?: string | null;
  currency?: string;
  id: string;
  marketplace?: boolean;
  minify?: boolean;
  storeName: string;
  textSize?: 'small' | 'normal';
};

const LocationAndCurrencyInfo = ({
  className,
  countryCode,
  countryName,
  currency,
  id,
  marketplace,
  minify = false,
  storeName,
  textSize = 'normal',
}: OwnProps) => {
  const { t } = useAppContext();

  const shouldMinify = minify && marketplace;

  const textIdentifier = `text-id-${id}`;

  const renderLocationAndCurrencyInfo = (locationAndCurrencyInfo: string) => (
    <S.LocationAndCurrencyInfo className={className}>
      <S.CountryFlag countryCode={countryCode} showTitleAsTooltip={false} />
      {shouldMinify ? (
        <ShowMore
          textIdentifier={textIdentifier}
          hideOnExpand
          maxHeight={32}
          size="small"
        >
          <S.Text id={textIdentifier} textSize={textSize}>
            {locationAndCurrencyInfo}
          </S.Text>
        </ShowMore>
      ) : (
        <S.Text textSize={textSize}>{locationAndCurrencyInfo}</S.Text>
      )}
    </S.LocationAndCurrencyInfo>
  );

  if (marketplace && storeName && countryName)
    return renderLocationAndCurrencyInfo(
      [
        t('store', 'store.is-marketplace', {
          storeName,
          country: countryName,
        }),
        currency &&
          t('store', 'store.uses-currency', {
            currency,
          }),
      ]
        .filter(item => item)
        .join(' ')
    );

  const locationAndCurrencyInfo = [
    countryName &&
      t('store', 'store.located-in', {
        country: countryName,
      }),
    currency &&
      t('store', 'store.uses-currency', {
        currency,
      }),
  ]
    .filter(item => item)
    .join(' ');

  return renderLocationAndCurrencyInfo(locationAndCurrencyInfo);
};

export default LocationAndCurrencyInfo;
